module.exports = __webpack_public_path__ + "media/styles/images/svg/oval-teal-3d46a2e4a17d4d93fbd3f8d3bcbadfd4.svg";